import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "p-1 h-100" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "d-flex align-items-center me-15 pb-2 mt-n2" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "bullet bullet-vertical bg-primary h-15px w-2px m-2 me-3" }),
  /*#__PURE__*/_createElementVNode("span", { class: "fw-bolder fs-6 text-dark" }, "Chargeback Prevention")
], -1)
const _hoisted_3 = { class: "fs-6 fw-semibold mb-2" }
const _hoisted_4 = {
  class: "row row-cols-1 row-cols-md-2 row-cols-lg-1 row-cols-xl-2 g-5",
  "data-kt-buttons": "true",
  "data-kt-buttons-target": "[data-kt-button='true']",
  "data-kt-initialized": "1"
}
const _hoisted_5 = { class: "col" }
const _hoisted_6 = {
  id: "add_alert_subdomain_toggle",
  title: "Alert subdomains",
  "data-bs-toggle": "tooltip",
  "data-bs-placement": "left",
  "data-bs-dismiss": "click"
}
const _hoisted_7 = {
  class: "btn btn-outline btn-outline-dashed btn-active-light-primary d-flex text-start p-6 bg-white",
  "data-kt-button": "true"
}
const _hoisted_8 = { class: "svg-icon svg-icon-2x svg-icon-primary d-block" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("span", { class: "ms-2" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "fs-7 fw-bolder text-dark d-block my-1" }, "Alerts")
], -1)
const _hoisted_10 = { class: "col" }
const _hoisted_11 = {
  class: "btn btn-outline btn-outline-dashed btn-active-light-primary d-flex text-start p-6 bg-white",
  "data-kt-button": "true"
}
const _hoisted_12 = { class: "svg-icon svg-icon-2x svg-icon-primary d-block" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("span", { class: "ms-2" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "fs-7 fw-bolder text-dark d-block my-1" }, "GeoSpy")
], -1)
const _hoisted_14 = { class: "col" }
const _hoisted_15 = {
  class: "btn btn-outline btn-outline-dashed btn-active-light-primary d-flex text-start p-6 bg-white",
  "data-kt-button": "true"
}
const _hoisted_16 = { class: "svg-icon svg-icon-2x svg-icon-primary d-block" }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("span", { class: "ms-2" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "fs-7 fw-bolder text-dark d-block my-1" }, "FraudBot")
], -1)
const _hoisted_18 = { class: "col" }
const _hoisted_19 = {
  class: "btn btn-outline btn-outline-dashed btn-active-light-primary d-flex text-start p-6 bg-white",
  "data-kt-button": "true"
}
const _hoisted_20 = { class: "svg-icon svg-icon-2x svg-icon-primary d-block" }
const _hoisted_21 = /*#__PURE__*/_createElementVNode("span", { class: "ms-2" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "fs-7 fw-bolder text-dark d-block my-1" }, "VeriCart")
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_inline_svg = _resolveComponent("inline-svg")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("label", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("a", _hoisted_6, [
            _createElementVNode("label", _hoisted_7, [
              _createElementVNode("span", _hoisted_8, [
                _createVNode(_component_inline_svg, { src: "/media/icons/duotune/communication/com010.svg" })
              ]),
              _hoisted_9
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_10, [
          _createElementVNode("label", _hoisted_11, [
            _createElementVNode("span", _hoisted_12, [
              _createVNode(_component_inline_svg, { src: "/media/icons/duotune/general/gen004.svg" })
            ]),
            _hoisted_13
          ])
        ]),
        _createElementVNode("div", _hoisted_14, [
          _createElementVNode("label", _hoisted_15, [
            _createElementVNode("span", _hoisted_16, [
              _createVNode(_component_inline_svg, { src: "/media/icons/duotune/abstract/abs027.svg" })
            ]),
            _hoisted_17
          ])
        ]),
        _createElementVNode("div", _hoisted_18, [
          _createElementVNode("label", _hoisted_19, [
            _createElementVNode("span", _hoisted_20, [
              _createVNode(_component_inline_svg, { src: "/media/icons/duotune/communication/com010.svg" })
            ]),
            _hoisted_21
          ])
        ])
      ])
    ])
  ]))
}